export const piiSharingConstants = {
  FETCH_PII_SHARING_CONFIGS_REQUEST: 'FETCH_PII_SHARING_CONFIGS_REQUEST',
  FETCH_PII_SHARING_CONFIGS_SUCCESS: 'FETCH_PII_SHARING_CONFIGS_SUCCESS',
  FETCH_PII_SHARING_CONFIGS_FAILURE: 'FETCH_PII_SHARING_CONFIGS_FAILURE',
  UPDATE_PII_SHARING_CONFIG_SUCCESS: 'UPDATE_PII_SHARING_CONFIG_SUCCESS',
  UPDATE_PII_SHARING_CONFIG_FAILURE: 'UPDATE_PII_SHARING_CONFIG_FAILURE'
};

const fetchPiiSharingConfigsRequest = () => {
  return {
    type: piiSharingConstants.FETCH_PII_SHARING_CONFIGS_REQUEST
  };
};

const fetchPiiSharingConfigsSuccess = (configs) => {
  return {
    type: piiSharingConstants.FETCH_PII_SHARING_CONFIGS_SUCCESS,
    payload: configs
  };
};

const fetchPiiSharingConfigsFailure = (error) => {
  return {
    type: piiSharingConstants.FETCH_PII_SHARING_CONFIGS_FAILURE,
    error
  };
};

const updatePiiSharingConfigSuccess = (courseId, enabled) => {
  return {
    type: piiSharingConstants.UPDATE_PII_SHARING_CONFIG_SUCCESS,
    payload: { courseId, enabled }
  };
};

const updatePiiSharingConfigFailure = (courseId, enabled) => {
  return {
    type: piiSharingConstants.UPDATE_PII_SHARING_CONFIG_FAILURE,
    payload: { courseId, enabled }
  };
};

export const piiSharingDispatches = {
  fetchPiiSharingConfigsRequest,
  fetchPiiSharingConfigsSuccess,
  fetchPiiSharingConfigsFailure,
  updatePiiSharingConfigSuccess,
  updatePiiSharingConfigFailure
};
